module.exports = __webpack_public_path__ + "0cd3ce2cce91bc58a9bbcb324fda4811.png";